<template>
  <div>
    <div class="my-6">
      <h3 class="font-bold">Buscar Pedidos</h3>
      <span class="text-sm text-gray-500">Aqui você pode ver detalhes do pedido. Basta digitar o código da
        transação no campo abaixo.
      </span>
    </div>
    <div class="card shadow-sm border p-2 bg-white">
      <div v-if="camera" class=" flex justify-center items-center flex-col  gap-5">
        <div class="w-full flex justify-end">
          <fa :icon="`fa-solid fa-x`" size="xl" @click="closeCamera()" />
        </div>
        <StreamBarcodeReader @decode="onDecode"></StreamBarcodeReader>
      </div>
      <div class="flex p-2 gap-2 items-center sm:items:start h-fit flex-col sm:flex-row ">
        <div class="flex-1 w-full">
          <Input v-model="code" @enter-pressed="getPedidos" 
          :placeholder="byDocumento === 'false' || !byDocumento ? 'Código do pedido' : 'Documento'"
          :label="byDocumento === 'false'|| !byDocumento ? 'Código do pedido' : 'Documento'" type="search" class="w-full" id="campo-busca"/>

          <div class="flex gap-2 mt-1 justify-between sm:justify-start ">
            <div class="w-full flex items-center gap-2">
              <input type="radio" id="pedido" value="false" v-model="byDocumento"
                class="form-radio text-primary focus:ring-primary" />
              <label for="pedido" class="text-gray-800 cursor-pointer text-xl md:text-sm">
                Pedido
              </label>
            </div>

            <!-- Opção de Documento -->
            <div class="w-full flex items-center gap-2">
              <input type="radio" id="documento" value="true" v-model="byDocumento"
                class="form-radio text-primary focus:ring-primary" />
              <label for="documento" class="text-gray-800 cursor-pointer text-xl md:text-sm">
                Documento
              </label>
            </div>
          </div>

        </div>
        <div class="flex flex-wrap sm:flex-nowrap gap-2 items-center sm:h-6 sm:items-end">
          <!-- Botão de Buscar (primeiro em telas grandes) -->
          <div class="order-2 sm:order-1 flex-1 sm:flex-none">
            <button
              class="w-full bg-primary rounded-md shadow-md px-5 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-2"
              @click="getPedidos">
              <label class="text-white cursor-pointer mr-1">Buscar</label>
              <fa class="text-white" :icon="`fa-solid fa-search`" size="lg" />
            </button>
          </div>

          <!-- Botão de Copiar -->
          <div class="order-1 sm:order-2 flex-1 sm:flex-none">
            <button
              class="w-full bg-primary rounded-md shadow-md px-5 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-2"
              @click="copyValue(code)">
              <label class="text-white cursor-pointer mr-1 md:hidden">Copiar</label>
              <fa icon="fa-solid fa-clone" size="lg" class="cursor-pointer text-white" />
            </button>
          </div>
          <!-- Botão de Ler pela câmera -->
          <div class="order-3 sm:order-3 flex-1 sm:flex-none w-full sm:w-auto">
            <button
              class="w-full sm:w-auto bg-terciary rounded-md shadow-md px-5 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-2"
              @click="showCamera">
              <label class="text-white cursor-pointer mr-1  md:hidden">Ler pela câmera</label>
              <fa class="text-white" :icon="`fa-solid fa-camera`" size="lg" />
            </button>
          </div>
        </div>



      </div>
    </div>

    <p>{{ erro }}</p>


    <div v-if="qrcodeNaoEncontrado"
      class="text-center font-medium flex justify-center items-center opacity-75 my-2 mt-5">
      {{ qrcodeNaoEncontrado }}
      <i class="ml-3 gg-ghost-character"></i>
    </div>

    <div class="card shadow-sm border p-2 bg-white mt-3" v-if="gotData">
      <Accordion v-for="(venda) in data" v-bind:key="venda.transacao" :title="`Pedido nº: ${venda.transacao}`"
        :backgroundColor="venda.cancelado && 'bg-red-500'">
        <div :class="`flex my-2 gap-4 flex-row sm:flex-row flex-col`">
          <div>

            <button
              class="bg-terciary rounded-md shadow-md transform px-2 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-1"
              @click="toggle">
              <label class="text-white cursor-pointer" for="logo3">{{
                expand ? "Fechar todos" : "Expandir todos"
              }}</label>
            </button>

          </div>
          <div class="flex-1 flex  gap-4 flex-row sm:flex-row flex-col">


            <button
              class="bg-primary rounded-md shadow-md transform px-2 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-1"
              @click="gerarQrcodeByVenda(venda.id)">
              <label class="text-white cursor-pointer" for="logo3">Visualizar Ingressos</label>
            </button>

            <button
              v-if="venda.venda_produto.some(vp => vp.produto && vp.produto.evento && vp.produto.evento.configEvento)"
              class=" bg-primary rounded-md shadow-md transform px-2 flex justify-center items-center font-bold
              cursor-pointer disabled:opacity-50 py-1" @click="sendPedidoToCatraca(venda.id)">
              <label class="text-white cursor-pointer" for="logo3">Reenviar Venda Catraca</label>
            </button>


            <button
              class="bg-primary rounded-md shadow-md transform px-2 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-1"
              @click="searchInFila(venda.transacao)">
              <label class="text-white cursor-pointer" for="logo3">Procurar na Fila</label>
            </button>


            <button
              v-if="venda.venda_produto.some(vp => vp.produto && vp.produto.evento && vp.produto.evento.configEvento)"
              class="bg-primary rounded-md shadow-md transform px-2 flex justify-center items-center font-bold cursor-pointer disabled:opacity-50 py-1"
              @click="searchInCatraca(venda.transacao)">
              <label class="text-white cursor-pointer" for="logo3">Procurar na Catraca</label>
            </button>

          </div>
        </div>

        <Accordion title="Dados da Compra" :expand="expand">
          <div class="flex flex-col p-2 m-2 overflow-x-auto">
            <div class="flex gap-2">
              <b>Transação nº:</b>
              <span class="capitalize">{{ venda.transacao }}</span>
            </div>
            <div class="flex gap-2">
              <b>Data:</b>
              <span class="capitalize">{{
                new Date(venda.data).toLocaleDateString("pt-BR")
              }}</span>
            </div>
            <div class="flex gap-2">
              <b>Hora:</b>
              <span class="capitalize">{{
                new Date(venda.data).toLocaleTimeString("pt-BR")
              }}</span>
            </div>

            <div class="flex gap-2">
              <b>Status do Pedido:</b>
              <span class="capitalize" v-if="venda['status_pedido'] === 1"> Voucher Ativo </span>
              <span class="capitalize" v-else-if="venda['status_pedido'] === 2"> Voucher Cancelado </span>
            </div>

            <div class="flex gap-2" v-if="venda.cancelado">
              <b>Cancelado</b>
              <span class="capitalize">{{ (venda.cancelado && venda.cancelado.motivo) ? venda.cancelado.motivo.motivo :
                'Venda Cancelada' }}</span>
            </div>

            <div class="flex gap-2">
              <b>Gateway Pagamento:</b>
              <span class="capitalize">{{ venda.id_gateway_pagamento.nome }}</span>
            </div>

            <div class="flex gap-2">
              <b>Vendedor:</b>
              <span class="capitalize">{{
                venda.vendedor
              }}</span>
            </div>
          </div>
        </Accordion>

        <Accordion title="Dados do Comprador" :expand="expand">
          <div class="flex flex-col p-2 m-2 overflow-x-auto">
            <div class="flex gap-2">
              <b>Nome:</b>
              <span class="capitalize">{{ venda.nome }}</span>
            </div>
            <div class="flex gap-2">
              <b>CPF:</b>
              <span>{{ numberToCpf(venda.cpf) }}</span>
            </div>
            <div class="flex gap-2">
              <b>Telefone:</b>
              <span>{{ numberToCel(venda.telefone) }}</span>
            </div>
            <div class="flex gap-2">
              <b>E-mail:</b>
              <span>{{ venda.email }}</span>
            </div>
            <div class="flex gap-2">
              <b>Endereço:</b>
              <span>{{ venda.endereco }}</span>
            </div>
            <div class="flex gap-2" v-if="venda.complemento">
              <b>Complemento:</b>
              <span>{{ venda.complemento }}</span>
            </div>
            <div class="flex gap-2">
              <b>Bairro:</b>
              <span>{{ venda.bairro }}</span>
            </div>
            <div class="flex gap-2">
              <b>Cidade:</b>
              <span>{{ venda.cidade }} - {{ venda.estado }} </span>
            </div>
            <div class="flex gap-2">
              <b>CEP:</b>
              <span>{{ numberToCep(venda.cep ?? '0000000000') }} </span>
            </div>
          </div>
        </Accordion>

        <Accordion v-for="(produto, evento) in agrupaVendaProdutosEvento(venda.venda_produto)" v-bind:key="evento"
          :title="`Itens do carrinho - ${evento}`" :expand="expand">

          <Accordion title="Dados do Evento" :expand="expand">
            <div class="flex flex-col p-2 m-2 overflow-x-auto" v-bind:key="vi">

              <div class="flex gap-2">
                <b>Nome:</b>
                <span class="capitalize">{{ produto.evento.nome }}</span>
              </div>
              <div class="flex gap-2">
                <b>Data Início:</b>
                <span class="capitalize">{{
                  new Date(produto.evento.data_inicio).toLocaleDateString("pt-BR")
                }}</span>
              </div>
              <div class="flex gap-2">
                <b>Data Fim:</b>
                <span class="capitalize">{{
                  new Date(produto.evento.data_fim).toLocaleDateString("pt-BR")
                }}</span>
              </div>
            </div>
          </Accordion>

          <Accordion v-for="(v, vp) in produto.produtos" v-bind:key="vp" :title="`${v.produto.detalhes}`"
            :expand="expand">

            <div class="w-full flex flex-col p-2 overflow-x-auto">
              <div class="flex gap-2">
                <b>Nome: </b>
                <span>{{ v.produto.detalhes }}</span>
              </div>
              <div class="flex gap-2">
                <b>SKU:</b>
                <span class="capitalize">{{ v.produto.cod_produto }}</span>
              </div>

              <div class="flex gap-2">
                <b>Valor original:</b>
                <span class="capitalize">{{ toMoney(v.produto.valor) }}</span>
              </div>
              <div class="flex gap-2">
                <b>Valor da loja:</b>
                <span class="capitalize">{{ toMoney(v.produto.valor) }}</span>
              </div>

              <div class="flex gap-2">
                <b>Setor: </b>
                <span class="capitalize">{{
                  v.produto.setor.nome
                }}</span>
              </div>
              <div class="flex gap-2">
                <b>PDV: </b>
                <span class="capitalize">{{ v.produto.pdv.nome }}</span>
              </div>

              <div class="flex gap-2">
                <b>Quantidade: </b>
                <span class="capitalize">{{ v.qtde }}</span>
              </div>
            </div>
          </Accordion>
        </Accordion>

        <Accordion title="Dados de Leitura" :expand="expand">
          <Accordion v-for="(venda_produto) in venda.venda_produto" v-bind:key="venda_produto.id"
            :title="venda_produto.produto.detalhes" :expand="expand">
            <Accordion v-for="(qrcode) in venda_produto.qrcode" v-bind:key="qrcode.qrcode"
              :title="`${venda.transacao}/${qrcode.identificador} - Ingresso ${qrcode.leituras[0] ? 'Lido' : 'Nâo Lido'}`"
              :expand="expand" :colorText="qrcode.leituras[0] ? 'text-red-500' : 'text-green_primary'"
              :backgroundColor="qrcode.leituras[0] ? 'bg-red-500 bg-opacity-25' : 'bg-green_primary bg-opacity-25'">
              <div class="flex flex-col p-2 m-2">
                <div class="flex gap-2">
                  <b>Identificador:</b>
                  <span class="capitalize">{{ qrcode.identificador }}</span>
                </div>
                <div class="flex flex-col" v-if="qrcode.qrcode">
                  <div class="flex gap-2">
                    <b>QR Code: </b>
                    <span class="capitalize">{{ qrcode.qrcode }}</span>
                  </div>
                  <div class="flex gap-2" v-if="qrcode.leituras[0]">
                    <b>Data da leitura: </b>
                    <span class="capitalize">{{
                      new Date(qrcode.leituras[0].data_leitura).toLocaleDateString(
                        "pt-BR"
                      )
                    }}
                      -
                      {{
                        new Date(qrcode.leituras[0].data_leitura).toLocaleTimeString(
                          "pt-BR"
                        )
                      }}</span>
                  </div>
                  <div v-if="qrcode.leituras[0]">
                    <div class="flex gap-2" v-if="qrcode.leituras[0].aparelho">
                      <b>Nome do Aparelho: </b>
                      <span class="capitalize">{{ qrcode.leituras[0].aparelho.nome_operador }}</span>
                    </div>
                    <div class="flex gap-2" v-else>
                      <b>ID do aparelho: </b>
                      <span class="capitalize">{{ qrcode.leituras[0].id_aparelho }}</span>
                    </div>

                  </div>
                  <div class="flex gap-2" v-if="qrcode.leituras[0]">
                    <b>status de leitura: </b>
                    <span class="capitalize">{{ qrcode.leituras[0].status }}</span>
                  </div>
                </div>
                <div class="text-center font-medium flex justify-center items-center opacity-75 my-2"
                  v-if="!qrcode.leituras[0]">
                  Nenhum dado de leitura encontrado...
                  <i class="ml-3 gg-ghost-character"></i>
                </div>
              </div>
            </Accordion>
          </Accordion>
        </Accordion>

      </Accordion>
    </div>

    <div class="card shadow-sm border p-8 mt-3 bg-white" v-if="flag">
      <div class="text-center font-medium flex justify-center items-center opacity-75">
        Nenhum item encontrado... <i class="ml-3 gg-ghost-character"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/Elements/Input.vue";
import { defineComponent, ref, inject, onMounted, watch } from "vue";
import alert from "@/services/alert";
import { POST, GET } from "@/services/api";
import Accordion from "@/components/Elements/Accordion.vue";
import {
  numberToCpf,
  numberToCel,
  numberToCep,
  toMoney,
} from "@/services/formater";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default defineComponent({
  name: "PedidosScreen",
  components: {
    Input,
    Accordion,
    StreamBarcodeReader
  },
  data() {
    return {
      isMobile: false,
      torchStatus: true,
    };
  },
  created() {
    this.isMobile = window.innerWidth < 800 ? true : false;
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 800 ? true : false;
    })
  },

  setup: () => {
    const code = ref("");
    const data = ref([]);
    const vendaProduto = ref([]);
    const qrcode = ref([]);
    const flag = ref(false);
    const gotData = ref(false);
    const loader = inject("loading");
    const modalLog = inject("modalProcuraIngresso");
    const modalIngresso = inject("modalIngresso");
    const camera = ref(false)
    const erro = ref('')
    const qrcodeNaoEncontrado = ref('')
    const trava = ref(0)
    const byDocumento = ref(false)

    const expand = ref(false);



    onMounted(() => {
      loader.close();
    });


    function toggle(){
      expand.value = !expand.value;
    }


    function fecharTeclado() {
      const campoBusca = document.getElementById("campo-busca");
      campoBusca.blur(); // Remove o foco do input, fechando o teclado
    }

    const getPedidos = async () => {
      fecharTeclado()
      expand.value = false;
      if (code.value.length < 1) {
        console.log()
        alert.open(
          "Atenção!",
          "Digite o código da transação para buscar os pedidos.",
          "error"
        );
        return;
      } else {
        loader.open();
        data.value = [];
        vendaProduto.value = [];
        qrcode.value = [];
        try {
          const res = await POST("/pedido",
            {
              id: code.value,
              byDocumento: byDocumento.value === 'true'
            });
          if (res.length > 0) {
            gotData.value = true;
            flag.value = false;
            for (const key in res) {
              data.value.push(res[key]);
            }
            console.log(data.value)

          } else {
            loader.close();
            flag.value = true;
          }
        } catch (error) {
          loader.close();
          console.log(error);
        } finally {
          loader.close();
        }
      }
    };

    const showCamera = () => {
      try {
        camera.value = !camera.value
      } catch (e) {
        console.log(e)
      }
    }

    const onDecode = async (decodedString) => {
      trava.value += 1
      if (trava.value === 1) {
        try {
          vendaProduto.value = null
          gotData.value = false
          const res = await POST("/pedido/qrcode", { id: decodedString });
          camera.value = false
          byDocumento.value = false
          if (res) {
            code.value = res
            qrcodeNaoEncontrado.value = ""
            getPedidos()
          } else {
            qrcodeNaoEncontrado.value = "Nenhuma transação relacionada a esse QRcode!!"
            code.value = ''
          }

        } catch (error) {
          loader.close();
          erro.value = error
          console.log(error);
        } finally {
          trava.value = 0
        }
      }
    }

    async function searchInFila(pedido) {
      try {
        if (!pedido) {
          alert.open(
            "Atenção!",
            "Digite o código da transação para buscar os pedidos.",
            "warning"
          );
          return;
        }


        loader.open();
        const res = await GET(`/fila_processo/venda/${pedido}`);
        loader.close();
        if (res && res.success) {
          // colocar no modal
          modalLog.open(JSON.stringify(res.data), false, pedido);

        }


      } catch (error) {
        alert.open(
          "Atenção!",
          "Não foi possivel encontrar o pedido na Fila.",
          "error"
        );
        loader.close();
      } finally {
        loader.close();
      }
    }

    async function searchInCatraca(pedido) {
      try {
        if (!pedido) {
          alert.open(
            "Atenção!",
            "Digite o código da transação para buscar os pedidos.",
            "warning"
          );
          return;
        }


        loader.open();
        const res = await GET(`/catraca/venda/${pedido}`);

        if (res && res.success) {
          // colocar no modal
          modalLog.open(JSON.stringify(res.data), true);

        }

        loader.close();
      } catch (error) {
        alert.open(
          "Atenção!",
          "Não foi possivel encontrar o pedido na Fila.",
          "error"
        );
        loader.close();
      }
    }

    async function sendPedidoToCatraca(pedidoId) {
      try {
        if (!pedidoId) {
          alert.open(
            "Atenção!",
            "Digite o código da transação para buscar os pedidos.",
            "warning"
          );
          return;
        }

        loader.open();
        const res = await POST(`/catraca/reenvio_venda`, {
          "id_venda": pedidoId
        });

        if (res && res.success) {
          // colocar no modal
          alert.open(
            "Sucesso!",
            "Pedido Reenviado para a catraca.",
            "success"
          );
        }

        loader.close();
      } catch (error) {
        alert.open(
          "Atenção!",
          "Não foi possivel reenviar o pedido para a Catraca.",
          "error"
        );
        loader.close();
      }
    }

    async function gerarQrcodeByVenda(pedidoId) {
      try {
        if (!pedidoId) {
          alert.open(
            "Atenção!",
            "Digite o código da transação para buscar os pedidos.",
            "warning"
          );
          return;
        }

        loader.open();
        const res = await GET(`/vendas/${pedidoId}/ingresso_V2`);

        if (res && res.success) {
          modalIngresso.open(res.data[0]);

        } else {
          alert.open(
            "Atenção!",
            "Nâo foi possivel recuperar os ingressos dessa venda",
            "success"
          );
        }

        loader.close();
      } catch (error) {
        alert.open(
          "Atenção!",
          "Nâo foi possivel recuperar os ingressos dessa venda",
          "error"
        );
        loader.close();
      }
    }

    function copyValue(value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          alert.open("Sucesso!", "Valor copiado para a área de transferência", "success");
        })
        .catch((err) => {
          console.error('Erro ao copiar o valor:', err);
        });
    }


    function agrupaVendaProdutosEvento(vendaProduto) {
      const agrupadoPorEvento = vendaProduto.reduce((acc, item) => {
        const eventoNome = item.produto.evento.nome;

        if (!acc[eventoNome]) {
          acc[eventoNome] = {
            evento: item.produto.evento,
            produtos: []
          };
        }
        acc[eventoNome].produtos.push(item);

        return acc;
      }, {});

      return agrupadoPorEvento
    }


    function closeCamera() {
      camera.value = false
    }

    return {
      code,
      data,
      getPedidos,
      gotData,
      flag,
      numberToCpf,
      numberToCel,
      numberToCep,
      toMoney,
      vendaProduto,
      qrcode,
      camera,
      showCamera,
      onDecode,
      erro,
      qrcodeNaoEncontrado,
      searchInFila,
      searchInCatraca,
      sendPedidoToCatraca,
      gerarQrcodeByVenda,
      copyValue,
      agrupaVendaProdutosEvento,
      closeCamera,
      byDocumento,
      toggle,
      expand
    };
  },
});
</script>

<style scoped>
.fundoQrCode {
  background-color: rgb(0, 0, 0);
  width: 500px;
}
</style>
